import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Data2Service } from '../../common/data2.service';

@Component({
	selector: 'app-post-document-types',
	templateUrl: './post-document-types.component.html',
	styleUrls: ['./post-document-types.component.css'],
})
export class PostDocumentTypesComponent {
	@Input() documentTypes: Array<any> = [];
	@Output() documentTypesChange = new EventEmitter();
	@Output() added = new EventEmitter();
	newName = '';

	constructor(private readonly api: Data2Service) {}

	submit() {
		this.api.post('/postDocumentTypes/', { name: this.newName }, (result, error) => {
			this.documentTypes.push({
				id: result.data,
				name: this.newName,
			});
			this.documentTypes.sort((a, b) => {
				if (a.name < b.name) {
					return -1;
				}
				if (a.name > b.name) {
					return 1;
				}
				return 0;
			});
			this.added.emit(true);
		});
	}
}
